import styled from 'styled-components';

import { layout, media } from '@prisjakt/ui-base';

import RichText from '../rich-text';

type TextTextProps = {};
export const TextText = styled.div<TextTextProps>`
  display: flex;
  flex-direction: row;
  justify-content: space-between;

  ${media.smallOnly`
    flex-direction: column;
  `};
`;

type TextProps = {
  width: string;
};

export const TextBefore = styled(RichText)<TextProps>`
  width: ${p => p.width};
  padding-right: ${layout.spacing.small};

  ${media.smallOnly`
    width: 100%;
    padding-right: 0;
    padding-bottom: ${layout.spacing.small};
  `};
`;

export const TextAfter = styled(RichText)<TextProps>`
  width: ${p => p.width};
  padding-left: ${layout.spacing.small};

  ${media.smallOnly`
    width: 100%;
    padding-left: 0;
    padding-top: ${layout.spacing.small};
  `};
`;
